import { ALLOWED_TONES, EMAIL_ACTIONS, JOB_POST_ACTIONS } from './consts';
import { withLocalePrefix } from '../../shared/utils/translation';

const t = withLocalePrefix('ai_tools');

const toTranslatedObject = (str: string, prefix: string) => {
  return {
    value: str,
    text: t(`${prefix}.${str}`),
  };
};

export const TONES = Object.freeze(
  ALLOWED_TONES.map((s) => toTranslatedObject(s, 'tones'))
);

export const TINY_MCE_EMAIL_ACTIONS = Object.freeze(
  EMAIL_ACTIONS.map((s) => toTranslatedObject(s, 'actions'))
);
export const TINY_MCE_JOB_POST_ACTIONS = Object.freeze(
  JOB_POST_ACTIONS.map((s) => toTranslatedObject(s, 'actions'))
);
